"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryOperationSource = void 0;
const bus_query_operation_1 = require("@comunica/bus-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
const utils_metadata_1 = require("@comunica/utils-metadata");
const utils_query_operation_1 = require("@comunica/utils-query-operation");
/**
 * A comunica Source Query Operation Actor.
 */
class ActorQueryOperationSource extends bus_query_operation_1.ActorQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(action) {
        const source = (0, utils_query_operation_1.getOperationSource)(action.operation);
        if (!source) {
            return (0, core_1.failTest)(`Actor ${this.name} requires an operation with source annotation.`);
        }
        if (!(0, utils_query_operation_1.doesShapeAcceptOperation)(await source.source.getSelectorShape(action.context), action.operation, { wildcardAcceptAllExtensionFunctions: true })) {
            return (0, core_1.failTest)(`Actor ${this.name} does not accept the operation ${action.operation.type}.`);
        }
        return (0, core_1.passTest)({ httpRequests: 1 });
    }
    async run(action) {
        // Log to physical plan
        const physicalQueryPlanLogger = action.context
            .get(context_entries_1.KeysInitQuery.physicalQueryPlanLogger);
        if (physicalQueryPlanLogger) {
            physicalQueryPlanLogger.logOperation(action.operation.type, undefined, action.operation, action.context.get(context_entries_1.KeysInitQuery.physicalQueryPlanNode), this.name, {});
            action.context = action.context.set(context_entries_1.KeysInitQuery.physicalQueryPlanNode, action.operation);
        }
        const sourceWrapper = (0, utils_query_operation_1.getOperationSource)(action.operation);
        const mergedContext = sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context;
        // Check if the operation is a CONSTRUCT query
        // We recurse because it may be wrapped in other operations such as SLICE and FROM
        let construct = false;
        utils_algebra_1.algebraUtils.visitOperation(action.operation, {
            [utils_algebra_1.Algebra.Types.CONSTRUCT]: { preVisitor: () => {
                    construct = true;
                    return { shortcut: true };
                } },
        });
        // If so, delegate to queryQuads
        if (construct) {
            const quadStream = sourceWrapper.source.queryQuads(action.operation, mergedContext);
            const metadata = (0, utils_metadata_1.getMetadataQuads)(quadStream);
            return {
                type: 'quads',
                quadStream,
                metadata,
            };
        }
        switch (action.operation.type) {
            case utils_algebra_1.Algebra.Types.ASK:
                return {
                    type: 'boolean',
                    execute: () => sourceWrapper.source.queryBoolean(action.operation, mergedContext),
                };
            case utils_algebra_1.Algebra.Types.COMPOSITE_UPDATE:
            case utils_algebra_1.Algebra.Types.DELETE_INSERT:
            case utils_algebra_1.Algebra.Types.LOAD:
            case utils_algebra_1.Algebra.Types.CLEAR:
            case utils_algebra_1.Algebra.Types.CREATE:
            case utils_algebra_1.Algebra.Types.DROP:
            case utils_algebra_1.Algebra.Types.ADD:
            case utils_algebra_1.Algebra.Types.MOVE:
            case utils_algebra_1.Algebra.Types.COPY:
                return {
                    type: 'void',
                    execute: () => sourceWrapper.source.queryVoid(action.operation, mergedContext),
                };
        }
        const bindingsStream = sourceWrapper.source.queryBindings(action.operation, mergedContext);
        const metadata = (0, utils_metadata_1.getMetadataBindings)(bindingsStream);
        return {
            type: 'bindings',
            bindingsStream,
            metadata,
        };
    }
}
exports.ActorQueryOperationSource = ActorQueryOperationSource;
//# sourceMappingURL=ActorQueryOperationSource.js.map